/**
 * Lightweight comparison to detect meaningful changes between old and new event data.
 * Used to skip expensive store updates + React re-renders when a reload fetches identical data.
 */
export function hasEventDataChanged(
  oldEvents: Array<{ updatedAt: Date }>,
  newEvents: Array<{ updatedAt: Date }>,
): boolean {
  if (oldEvents.length !== newEvents.length) return true;

  for (let i = 0; i < oldEvents.length; i++) {
    if (oldEvents[i].updatedAt.getTime() !== newEvents[i].updatedAt.getTime()) return true;
  }

  return false;
}
